// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuItem_container__3uqYt","titlePopup":"MenuItem_titlePopup__bno5F","active":"MenuItem_active__2uNBq"};